/* MAMA-XSELL — ajout au panier depuis l'encart cross-sell (PDP + tiroir).
   Reproduit le pattern natif Horizon : POST cart_add_url avec `sections`,
   puis dispatch d'un event 'cart:update' porteur des sections rendues
   -> les <cart-items-component> se morphent, et <cart-drawer-component auto-open> s'ouvre. */
(function () {
  if (window.__mamaXsell) return;
  window.__mamaXsell = true;

  function addUrl() {
    try { if (window.Theme && Theme.routes && Theme.routes.cart_add_url) return Theme.routes.cart_add_url; } catch (e) {}
    try { if (window.routes && window.routes.cart_add_url) return window.routes.cart_add_url; } catch (e) {}
    return '/cart/add';
  }

  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      var id = (el.dataset && el.dataset.sectionId) || el.getAttribute('data-section-id');
      if (!id) {
        var sec = el.closest('.shopify-section');
        if (sec && sec.id) id = sec.id.replace('shopify-section-', '');
      }
      if (id && ids.indexOf(id) < 0) ids.push(id);
    });
    return ids;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mama-xsell-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;

    var vid = btn.getAttribute('data-mama-xsell-add');
    var href = btn.getAttribute('data-href');
    if (!vid) { if (href) location.href = href; return; }

    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');

    var sids = cartSectionIds();
    var body = new FormData();
    body.append('id', vid);
    body.append('quantity', '1');
    if (sids.length) { body.append('sections', sids.join(',')); body.append('sections_url', location.pathname); }

    fetch(addUrl() + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok || (r.data && r.data.status)) {
          throw new Error((r.data && (r.data.description || r.data.message)) || 'add_error');
        }
        var sections = r.data && r.data.sections ? r.data.sections : null;
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (c) { return c.json(); })
          .catch(function () { return null; })
          .then(function (cart) {
            var detail = {
              resource: cart || {},
              sourceId: 'mama-crosssell',
              data: {
                source: 'mama-crosssell',
                productId: btn.getAttribute('data-pid'),
                variantId: vid,
                itemCount: cart ? cart.item_count : null,
                sections: sections
              }
            };
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: detail }));
            btn.classList.remove('is-loading');
            btn.classList.add('is-added');
            setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
          });
      })
      .catch(function (err) {
        console.warn('[mama-crosssell]', err);
        btn.classList.remove('is-loading');
        if (href) location.href = href;
      })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  });
})();

/* MAMA-XSELL-REFRESH (06/10/2026, bug vu par Anthony pendant la commande test) : le panneau « Compléter votre panier »
   à GAUCHE du tiroir (ordinateur) est posé hors de la zone que le thème redessine quand on change une quantité ou
   supprime un article (le thème ne redessine alors que .cart-drawer__inner) → les suggestions restaient celles des
   articles supprimés. À chaque 'cart:update', on remplace le panneau par celui du HTML de section que le thème vient
   de recevoir (sinon on redemande la section) ; panier vide → panneau retiré. Script chargé partout depuis mama_global. */
(function () {
  if (window.__mamaXsellRefresh) return;
  window.__mamaXsellRefresh = true;

  function drawerSectionId() {
    var c = document.querySelector('cart-items-component[data-drawer]');
    return c ? c.getAttribute('data-section-id') : null;
  }

  function apply(html) {
    var dialog = document.querySelector('.cart-drawer__dialog');
    if (!dialog || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    if (!doc.querySelector('.cart-drawer__dialog')) return;
    var fresh = doc.querySelector('.cart-drawer__dialog .mama-xsell-drawer');
    var cur = dialog.querySelector('.mama-xsell-drawer');
    if (!fresh) { if (cur) cur.remove(); return; }
    if (cur) { if (cur.innerHTML !== fresh.innerHTML) cur.innerHTML = fresh.innerHTML; }
    else dialog.insertBefore(document.importNode(fresh, true), dialog.firstChild);
  }

  document.addEventListener('cart:update', function (e) {
    var id = drawerSectionId();
    if (!id) return;
    var secs = e && e.detail && e.detail.data && e.detail.data.sections;
    var html = secs && secs[id];
    // après le travail du thème sur la même mise à jour
    setTimeout(function () {
      if (html) { apply(html); return; }
      fetch(location.pathname + '?section_id=' + encodeURIComponent(id), { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(apply)
        .catch(function () {});
    }, 0);
  });
})();
